import { api } from "@/services/api";

export type ScheduleResponseHour = {
  hora: number;
  hora_fim: number;
  pedidos: string[];
  disponivel: boolean;
};

export type ScheduleResponse = {
  num_dia: number;
  desc_dia: string;
  horarios: ScheduleResponseHour[];
  entrega_expressa_disponivel: boolean;
  entrega_programada_disponivel: boolean;
  data: string;
};

export async function checkAvailableScheduleDates(currentIsoDate: string, storeId: string) {
  const { data } = await api.post<ScheduleResponse[]>(
    "/pedidos/checar-data-agendamento-disponivel-v3",
    {
      dataAgendamento: currentIsoDate,
      estabelecimento: storeId,
    }
  );
  return data;
}
